import { type IWidgetType } from '../IWidgetType.ts';
import { ButtonWidgetType } from './advanced/buttons/ButtonWidget.type.tsx';
import { CompanyWidgetType } from './advanced/company/CompanyWidget.type.tsx';
import { ConfirmWidgetType } from './advanced/confirm/ConfirmWidget.type.tsx';
import { PaymentRowWidgetType } from './advanced/payment-row/PaymentRowWidget.type.tsx';
import { RepeatControllerWidgetType } from './advanced/repeat-controller/RepeatControllerWidget.type.tsx';
import { RepeatableWidgetType } from './advanced/repeatable/RepeatableWidget.type.tsx';
import { SubsectionWidetType } from './advanced/subsection/SubsectionWidget.type.tsx';
import { SwitchWidgetType } from './advanced/switch/SwitchWidget.type.tsx';
import { TableInputWidgetType } from './advanced/table-input/TableInputWidget.type.tsx';
import { ComputedBooleanWidgetType } from './computed/boolean/ComputedBooleanWidget.type.tsx';
import { ComputedDateWidgetType } from './computed/date/ComputedDateWidget.type.tsx';
import { ComputedNumberWidgetType } from './computed/number/ComputedNumberWidget.type.tsx';
import { ComputedStringWidgetType } from './computed/string/ComputedStringWidget.type.tsx';
import { ColumnWidgetType } from './containers/column/ColumnWidget.type.tsx';
import { QuestionWidgetType } from './containers/question/QuestionWidget.type.tsx';
import { RowWidgetType } from './containers/row/RowWidget.type.tsx';
import { DividerWidgetType } from './graphics/divider/DividerWidget.type.tsx';
import { InfoWidgetType } from './graphics/info/InfoWidget.type.tsx';
import { PageWidgetType } from './graphics/page/PageWidget.type.tsx';
import { PageBreakWidgetType } from './graphics/page-break/PageBreakWidget.type.tsx';
import { ParagraphWidgetType } from './graphics/paragraph/ParagraphWidget.type.tsx';
import { AdvancedMultiSelectWidgetType } from './inputs/advanced-multi-select/AdvancedMultiSelectWidget.type.tsx';
import { AdvancedSingleSelectWidgetType } from './inputs/advanced-single-select/AdvancedSingleSelectWidget.type.tsx';
import { AsyncSelectWidgetType } from './inputs/async-select/AsyncSelectWidget.type.tsx';
import { AsyncValueWidgetType } from './inputs/async-value/AsyncValueWidget.type.tsx';
import { BooleanWidgetType } from './inputs/boolean/BooleanWidget.type.tsx';
import { CurrencyWidgetType } from './inputs/currency/CurrencyWidget.type.tsx';
import { DateWidgetType } from './inputs/date/DateWidget.type.tsx';
import { HiddenWidgetType } from './inputs/hidden/HiddenWidget.type.tsx';
import { MultiSelectWidgetType } from './inputs/multi-select/MultiSelectWidget.type.tsx';
import { NumberWidgetType } from './inputs/number/NumberWidget.type.tsx';
import { SingleSelectWidgetType } from './inputs/single-select/SingleSelectWidget.type.tsx';
import { TextWidgetType } from './inputs/text/TextWidget.type.tsx';

export function getAllWidgetTypes(): Array<IWidgetType<any>> {
  return [
    // Computed
    ComputedBooleanWidgetType,
    ComputedNumberWidgetType,
    ComputedStringWidgetType,
    ComputedDateWidgetType,
    ConfirmWidgetType,
    // Containers
    RowWidgetType,
    ColumnWidgetType,
    QuestionWidgetType,
    RepeatableWidgetType,
    SubsectionWidetType,
    CompanyWidgetType,
    // Graphics
    DividerWidgetType,
    PageBreakWidgetType,
    PageWidgetType,
    ParagraphWidgetType,
    InfoWidgetType,
    // Input
    BooleanWidgetType,
    CurrencyWidgetType,
    DateWidgetType,
    MultiSelectWidgetType,
    NumberWidgetType,
    SingleSelectWidgetType,
    AdvancedSingleSelectWidgetType,
    AdvancedMultiSelectWidgetType,
    AsyncSelectWidgetType,
    AsyncValueWidgetType,
    TextWidgetType,
    TableInputWidgetType,
    RepeatControllerWidgetType,
    HiddenWidgetType,
    SwitchWidgetType,
    // CompetenceWidgetType,
    // Azioni
    ButtonWidgetType,
    // Voci di Preventivo
    ...(process.env.BUILD_FLAGS_PAYMENT_TYPES ? [PaymentRowWidgetType] : []),
  ];
}
